module.exports = __webpack_public_path__ + "static/allfullpage-2eb5c28e901923130e43ab7f1aab97e8.mp4";